export default "__VITE_ASSET__CyWE2JfP__"